import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-company-virtual-interview',
  templateUrl: './company-virtual-interview.component.html',
  styleUrls: ['./company-virtual-interview.component.css'],
})
export class CompanyVirtualInterviewComponent implements OnInit {
  accessToken = localStorage.getItem('accessToken');
  vrId: string | null = null;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    this.vrId = this.route.snapshot.paramMap.get('id');
  }

  goToVirtualSteps() {
    if (!this.accessToken) {
      localStorage.setItem('redirectUrl', `/virtual-interview/${this.vrId}`);
      this.router.navigate(['/login']);
    } else {
      this.router.navigate([`/virtual-interview/${this.vrId}/start`]);
    }
  }
}
